import { Espece } from './espece.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class RefPorteGreffe {
    static jsonMap = {
        id: 'id',
        code: 'code',
        libelle: 'libelle',
        espece: { key: 'espece', converter: new (ClassConverterFactory.build(Espece))() }
    };

    id: number;
    code: string;
    libelle: string;
    espece: Espece = undefined;
}
